function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m16 277.332031c-1.984375 0-3.96875-.363281-5.867188-1.109375-6.121093-2.410156-10.132812-8.320312-10.132812-14.890625v-160c0-6.570312 4.011719-12.480469 10.132812-14.890625 6.144532-2.410156 13.078126-.851562 17.558594 3.96875l74.664063 80c5.761719 6.144532 5.761719 15.679688 0 21.824219l-74.664063 80c-3.09375 3.328125-7.339844 5.097656-11.691406 5.097656zm16-135.402343v78.804687l36.777344-39.402344zm0 0"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m474.667969 128h-330.667969c-20.585938 0-37.332031-16.746094-37.332031-37.332031v-53.335938c0-20.585937 16.746093-37.332031 37.332031-37.332031h330.667969c20.585937 0 37.332031 16.746094 37.332031 37.332031v53.335938c0 20.585937-16.746094 37.332031-37.332031 37.332031zm-330.667969-96c-2.945312 0-5.332031 2.390625-5.332031 5.332031v53.335938c0 2.941406 2.386719 5.332031 5.332031 5.332031h330.667969c2.941406 0 5.332031-2.390625 5.332031-5.332031v-53.335938c0-2.941406-2.390625-5.332031-5.332031-5.332031zm0 0"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m474.667969 469.332031h-330.667969c-20.585938 0-37.332031-16.746093-37.332031-37.332031v-160c0-20.585938 16.746093-37.332031 37.332031-37.332031h330.667969c20.585937 0 37.332031 16.746093 37.332031 37.332031v160c0 20.585938-16.746094 37.332031-37.332031 37.332031zm-330.667969-202.664062c-2.945312 0-5.332031 2.386719-5.332031 5.332031v160c0 2.945312 2.386719 5.332031 5.332031 5.332031h330.667969c2.941406 0 5.332031-2.386719 5.332031-5.332031v-160c0-2.945312-2.390625-5.332031-5.332031-5.332031zm0 0"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m309.332031 128c-8.832031 0-16-7.167969-16-16v-96c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v96c0 8.832031-7.167969 16-16 16zm0 0"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m309.332031 469.332031c-8.832031 0-16-7.167969-16-16v-202.664062c0-8.832031 7.167969-16 16-16s16 7.167969 16 16v202.664062c0 8.832031-7.167969 16-16 16zm0 0"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m496 368h-373.332031c-8.832031 0-16-7.167969-16-16s7.167969-16 16-16h373.332031c8.832031 0 16 7.167969 16 16s-7.167969 16-16 16zm0 0"
});

var SvgInsert = function SvgInsert(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 -21 512 512",
    width: "512pt",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInsert, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/insert.955d45bf.svg";
export { ForwardRef as ReactComponent };